<template>
  <div>
    <LessonHeader :hide-display="'hide_content'" />
    <div class="browser-container">
      <BrowserMessageDisplay :title="title" :description="description" />
      <div class="content">
        <div v-if="isStudent" class="recommended-text">
          <p v-html="$t('browserNotSupported.recommended')"></p>
        </div>
        <div v-for="browser in browsers" :key="browser.name" class="list">
          <a :href="browser.downloadLink" target="_blank">
            <p class="btn browser">
              <img src="~@/assets/img/download_icn.png" />{{ getBrowserText(browser) }}</p>
          </a>
        </div>
        <a>
          <div class="btn close" @click="closeCurrentTab">{{ $t('browserNotSupported.close') }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { supportedBrowsers } from '@/utils/constants';
import UAParser from 'ua-parser-js';

import BrowserMessageDisplay from '@/components/Browser/MessageDisplay';
import LessonHeader from '@/components/Lesson/Header/LessonHeader';

export default {
  components: {
    BrowserMessageDisplay,
    LessonHeader
  },
  data() {
    return {
      deviceInfo: new UAParser().getOS()
    };
  },
  computed: {
    ...mapGetters(['isStudent']),

    title() {
      return this.$t('browserNotSupported.title');
    },

    description() {
      return this.$t('browserNotSupported.description');
    },

    browsers() {
      return supportedBrowsers.filter(browser => browser.os.includes(this.conditionalOSBrowser));
    },
    
    conditionalOSBrowser() {
      const os = ['iOS', 'Android', 'Mac OS', 'Windows'];
      return os.includes(this.deviceInfo.name) ? this.deviceInfo.name : 'general';
    }
  },
  methods: {
    getBrowserText(browser) {
      const includeVersion = !this.isStudent ? browser.minVersion : '';
      return `${browser.label} ${includeVersion} ${this.$t('browserNotSupported.version')}`;
    },
    closeCurrentTab() {
      window.close();
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/css/pc/browser_message.css"></style>
<style scoped src="@/assets/css/sp/browser_message.css"></style>
